export default __webpack_public_path__ + "static/media/sesamo.3851a49d.svg";